import { Pagination, Table } from "@mantine/core";
import { format } from "date-fns";
import React, { useEffect } from "react";
import { match } from "ts-pattern";
import { useUploadHistories } from "@/hooks/useUploadHistories";
import { UploadStatus } from "@/models/uploadHistory";

const translateStatus = (status: UploadStatus) =>
  match(status)
    .with("QUEUED", () => "待機中")
    .with("RUNNING", () => "実行中")
    .with("FAILED", () => "失敗")
    .with("COMPLETED", () => "完了")
    .exhaustive();

export const UploadHistoryTable: React.FC = () => {
  const [page, setPage] = React.useState(1);
  const { uploadHistories, lastPage, total, isLoading, pageSize, mutate } = useUploadHistories(page);

  useEffect(() => {
    // アップロードページから遷移してきた場合に履歴が増えてる可能性があるため、コンポーネントロード時に再フェッチする
    mutate();
  }, []);

  if (isLoading || !uploadHistories) return <div>loading...</div>;

  return (
    <div>
      <Table data-testid="upload-history-table">
        <Table.Thead>
          <Table.Tr>
            <Table.Th>#</Table.Th>
            <Table.Th>ファイル名</Table.Th>
            <Table.Th>アップロード日時</Table.Th>
            <Table.Th>完了日時</Table.Th>
            <Table.Th>ステータス</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {uploadHistories.length > 0 && total
            ? uploadHistories.map((h, index) => (
              <Table.Tr key={h.id}>
                <Table.Td>{total - ((page - 1) * pageSize) - index}</Table.Td>
                <Table.Td maw="40vw">{h.fileName}</Table.Td>
                <Table.Td>{format(h.createdAt, "yyyy-MM-dd HH:mm:ss")}</Table.Td>
                <Table.Td>
                  {h.isCompleted && h.completedAt ? format(h.completedAt, "yyyy-MM-dd HH:mm:ss") : "-"}
                </Table.Td>
                <Table.Td>{translateStatus(h.status)}</Table.Td>
              </Table.Tr>
            ))
            : (
              <Table.Tr>
                <Table.Td colSpan={5} className="text-center h-15">実行済のアップロード履歴はありません</Table.Td>
              </Table.Tr>
            )}
        </Table.Tbody>
      </Table>
      {lastPage && lastPage > 1 && (
        <Pagination className="flex mt-10 justify-center" value={page} onChange={setPage} total={lastPage} />
      )}
    </div>
  );
};
